import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'HIPAA Compliant',
      description: 'Healthcare data protection'
    },
    {
      icon: 'Lock',
      text: 'SSL Encrypted',
      description: 'Secure data transmission'
    },
    {
      icon: 'CheckCircle',
      text: 'Medical Grade Security',
      description: 'Industry standard protection'
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg border border-border/50"
          >
            <Icon 
              name={feature?.icon} 
              size={16} 
              color="var(--color-success)" 
            />
            <div className="text-center">
              <div className="text-xs font-medium text-foreground">
                {feature?.text}
              </div>
              <div className="text-xs text-muted-foreground">
                {feature?.description}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground">
          Your health data is protected with enterprise-grade security measures
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;